import { ResponsiveMenuItem } from 'components/DropdownButtons/_utils/ResponsiveMenuItem'
import { KcBlockSettingsModalButton } from 'components/KcBlockSettingsModalButton/KcBlockSettingsModalButton'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { selectedPropertyHasPermission } from '../../_utils/selectedPropertyHasPermission'

export const EvapotranspirationTitleLink = () => {
  if (!selectedPropertyHasPermission({ permission: 'EDIT_EVAPOTRANSPIRATION_COEFFICIENTS' })) {
    return []
  }

  return [
    <>
      <ResponsiveMenuItem
        key="evapotranspiration-menu-item"
        data-role="menu-item"
        onClick={() => {
          detailsPanelStore.setState((prev) => {
            return {
              ...prev,
              kcBlockSettingsModalOpened: true,
            }
          })
        }}
      >
        {translate.phrases.banyanApp('Select Kc Models')}
      </ResponsiveMenuItem>
      <KcBlockSettingsModalButton key="evapotranspiration-modal" data-role="modal" />
    </>,
  ]
}
